import React from "react";
type Observation = {
  provider?: string;
  checkedAt?: Date | string | null;
  rawAnswer?: string | null;
  analysisStatus?: string | null;
  analysisError?: string | null;
  entityLevel?: string | null;
  entityLevelReason?: string | null;
};

export default function AiObservationDetails({ rows }: { rows: Observation[] }) {
  const observations = rows.filter(row => row.rawAnswer || row.analysisStatus).slice(0, 12);
  if (!observations.length) return null;
  return <section aria-label="AI 回答與判讀依據" className="space-y-3">
    <h3 className="font-semibold">AI 回答與判讀依據</h3>
    {observations.map((row, index) => <details key={`${row.provider}-${index}`} className="rounded border p-3 text-sm">
      <summary className="cursor-pointer font-medium">
        {row.provider?.toUpperCase()} · {row.checkedAt ? new Date(row.checkedAt).toLocaleString("zh-TW", { timeZone: "Asia/Taipei" }) : "尚無時間"} · {row.analysisStatus === "error" ? "分析失敗" : row.analysisStatus === "success" ? "判讀成功" : "待分析"}
      </summary>
      <p className="mt-3 font-medium">AI 原始回答</p>
      <div className="mt-1 whitespace-pre-wrap break-words">{row.rawAnswer || "尚無回答紀錄"}</div>
      {row.analysisStatus === "error" ? <p role="alert" className="mt-3 text-amber-700">分析失敗：{row.analysisError || "未提供錯誤訊息"}</p>
        : row.analysisStatus === "success" ? <div className="mt-3"><p>判讀層級：{row.entityLevel || "尚無層級"}</p><p>判讀依據：{row.entityLevelReason || "尚無判讀依據"}</p></div>
          : <p className="mt-3">判讀尚未完成</p>}
    </details>)}
  </section>;
}
